// extracted by mini-css-extract-plugin
export var centerText = "_cn-8";
export var container = "_cn-0";
export var doughnutContainer = "_cn-7";
export var legend = "_cn-a";
export var legendItemColorDisplay = "_cn-b";
export var legendItemLabel = "_cn-d";
export var legendItemValue = "_cn-c";
export var lg = "_cn-5";
export var maxWidth = "_cn-9";
export var md = "_cn-4";
export var responsive = "_cn-6";
export var sm = "_cn-3";
export var xs = "_cn-2";
export var xxs = "_cn-1";